import React from "react";
import { cn } from "@/lib/utils";

interface Props {
  year: string;
  quarter: number;
  years: string[];
  onChange: (year: string, quarter: number) => void;
  /** Merged over the defaults, e.g. "mb-0" to sit in a row with other controls. */
  className?: string;
}

const QuarterYearSelector: React.FC<Props> = ({ year, quarter, years, onChange, className }) => {
  const quarterOptions = [
    { value: 1, label: "Q1" },
    { value: 2, label: "Q2" },
    { value: 3, label: "Q3" },
    { value: 4, label: "Q4" },
  ];

  return (
    <div className={cn("flex flex-wrap gap-3 items-center mb-4", className)}>
      {/* Year Selector */}
      <div className="flex flex-col">
        <label className="mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">Year</label>
        <select
          value={year}
          onChange={(e) => onChange(e.target.value, quarter)}
          className="border border-gray-300 dark:border-gray-600 rounded-md p-2 w-32 
                     bg-white dark:bg-gray-800 
                     text-gray-900 dark:text-gray-100
                     focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400"
        >
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>

      {/* Quarter Selector */}
      <div className="flex flex-col">
        <label className="mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">Quarter</label>
        <select
          value={quarter}
          onChange={(e) => onChange(year, parseInt(e.target.value))}
          className="border border-gray-300 dark:border-gray-600 rounded-md p-2 w-28 
                     bg-white dark:bg-gray-800 
                     text-gray-900 dark:text-gray-100
                     focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400"
        >
          {quarterOptions.map((q) => (
            <option key={q.value} value={q.value}>
              {q.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default QuarterYearSelector;